// Module
var code = `<div class="alert">
  <span>
    <strong>DISCLAIMER:</strong> This form can be used to undo the change product owner.
  </span>
</div>

<h2 class="section-header">Please confirm the following:</h2>
<form name="form">
  <table class="table">
    <tbody>
    <tr>
      <td>Product number:</td>
      <td>
        <input
          type="text"
          required
          minlength="1"
          maxlength="64"
          placeholder="Product number"
          ng-model="\$ctrl.productNumber"
          ng-change="\$ctrl.onProductChange(\$ctrl.productNumber)"/>
      </td>
    </tr>
    <tr>
      <td>New product owner</td>
      <td>
        <input
          type="text"
          disabled
          placeholder="Customer name"
          ng-model="\$ctrl.customer.effectiveName"/>
      </td>
    </tr>
    <tr>
      <td></td>
      <td>
        <customer-picker on-choose="\$ctrl.onCustomerChange(customer)"></customer-picker>
      </td>
    </tr>
    </tbody>
  </table>

  <div class="pull-right">
    <button
      type="submit"
      class=" btn btn-success"
      ng-disabled="form.\$invalid"
      ng-click="\$ctrl.execute()">
      Execute
    </button>
  </div>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/misc/update-product-ownership/update-product-ownership.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;